// Kunci `priceExtra` muatan penulis pesanan (Tambah Produk, CLOSED PO, Detail
// Produksi, Edit Pesanan) — tambahan (mig 7900) yang TERMASUK di `unitPrice`
// baris. Server (mig 8090, bughunt D15-30/33) mencocokkannya dengan tambahan
// varian hari ini: beda = harga dihitung dari tambahan lama → simpan ditolak
// "muat ulang". Kunci absen = perilaku lama (trigger memotret tambahan varian),
// jadi baris tanpa harga / tambahan tak diketahui TIDAK mengirimnya.

export function orderLinePriceExtraKey(l: {
  unitPrice: number | null | undefined;
  priceExtra?: number | null;
}): { priceExtra?: number } {
  if (l.unitPrice === null || l.unitPrice === undefined) return {};
  const x = l.priceExtra;
  return typeof x === "number" && Number.isFinite(x) ? { priceExtra: Math.max(0, Math.round(x)) } : {};
}
